export default {
  id: 'ImportStudent',
  code: 'CN',
  text: {
    'Follow the CSV template provided below': '请遵循提供的CSV表格模板格式',
    "If you would like to import students with customized data fields, please set it up at 'Administration'-->'Students'-->'Student Custom Fields'": "如果您的学生资料包括自定义项, 导入前请先在 '教务管理' --> '学员' --> '学员自定义字段' 进行设定",
    "Date has to be in format of 'YYYY-MM-DD'": "日期/生日格式必须为 'YYYY-MM-DD'",
    "Gender has to be either letter 'M' or 'F' or 'N/A'": "学生性别必须为字母 'M' 或 'F' 或 'N/A' (M代表男, F代表女, N/A代表未提供)", 
    "Email has to be in format of 'xxxx@xxx.xxx'": "邮件格式必须为 'xxxx@xxx.xxx'", 
    'Student Import Rules': '批量上传学生规则',
    'Modify your CSV file with our CSV template to help you import students at once': '您可以通过下载CSV表格模板，将学生数据按规则填入CSV表格中，一次性导入系统',
    'Drag and drop your CSV file here': '拖拽包含学员信息的CSV表格到这里',
    'Phone number is consisted with a Country code following by the phone number (numbers only, no space or other characters)' : '电话号码格式为: 国家区号加上本地电话号 (必须为数字, 不能包含空格和任何其他字符)',
    "Value of the 'select' (single choice) custom field has to be only one of its choices": "单选项的自定义字段输入值只能为其众多选项之一",
    "Value of the 'checkbox' (multiple choice) custom field has to be one or more of its choices, seperated by comma. For example: 'english, math, science'" : "多选项的自定义字段输入值可以为其所有选项的一个或多个, 并用逗号隔开, 例如: '篮球, 滑雪, 游泳'",
    'Or select a file from your computer...': '或者在您的电脑中选择CSV表格',
    'We found errors in your data. Please make sure to enter correct information.': '我们在即将导入的数据中发现了一些错误，请确认这些信息是否符合导入规则或是否有错误。',
    'Your import, file {filename} has {rowNum} rows, and {errorNum} errors.': '您即将导入的CSV表格文件({filename})中有{rowNum}行，有{errorNum}个错误。',
    'Please review your data and click confirm to import.': '请检查您的数据，无误后单击确认开始导入',
    'Student Imports':'学生导入',

    'Remove': '删除',
    'Upload': '上传',
    'Finish': '完成',
    'Download CSV template': '下载CSV表格模板',

    'Upload CSV': '上传CSV',
    'Import': '导入',

    'Male': '男',
    'Female': '女',
    'Other': '其他',
    'None': '无',
    'Required column contains empty fields': '此必填项存在空数据',
    'Gender must be M or F': '性别必须为 M 或 F',
    'Contains invalid phone numbers (A country code followed by phone number, numbers only, no space or other characters)': '此项数据中的手机号码格式存在错误(国家区号加上电话号码, 只能为数字, 不能包含空格和其他字符)',
    "Contains invalid date format (it has to be in format of 'YYYY-MM-DD')" : "此项数据中日期格式存在错误 (格式为: 'YYYY-MM-DD')",
    "Contains invalid email format (it has to be in format of 'xxxx@xxx.xxx')": "此项数据中邮箱格式存在错误 (格式为: 'xxxx@xxx.xxx')",
    'Contains invalid selection options': '此项数据中包含错误的单选项',
    "Contains invalid checkbox options": '此项数据中包含错误的多选项',
    'Step {currentStep} of {totalStep}:': '进度 {currentStep}/{totalStep}：',
    'Which column contains the {label} of your students?': '右边哪一列数据包含学生的{label}',
    'Previous step': '上一步',
    'Skip this step': '跳过此步',
    'Basic Fields Mapping': '基本资料项匹配',
    'Custom Fields Mapping': '自定义资料项匹配',
    'Field Type': '类型',
    'Options': '选项',
    'text': '文本',
    'select': '单选',
    'checkbox': '多选',
    'Back to Basic Fields': '回到基本资料',
    'Back to Custom Fields': '回到自定义资料',
    'Firstname': '名字',
    'Lastname': '姓氏',
    'Gender': '性别',
    'DOB': '生日',
    'Student Phone': '学生电话',
    'Student Email': '学生邮箱',
    'Unit No.': '房间号',
    'Street': '街道名',
    "City": '城市',
    'Province/State': '省/州',
    'Country': '国家',
    'Postal Code': '邮编',
    'Nickname': '学员昵称',
    'Remark': '备注',
    'Primary Guardian Name': '家长1姓名',
    'Primary Guardian Phone': '家长1电话',
    'Primary Guardian Email': '家长1邮箱',
    'Primary Guardian Relationship': '家长1关系',      
    'Secondary Guardian Name': '家长2姓名',
    'Secondary Guardian Phone': '家长2电话',
    'Secondary Guardian Email': '家长2邮箱',  
    'Secondary Guardian Relationship': '家长2关系',
    'Map Basic Fields': '匹配基本资料项',
    'Map Custom Fields': '匹配自定义资料项',
    'Select this column': '选择此项',
    '{number} more rows': '还有{number}行数据',
    'Column': '列',
    'Mapped as': '匹配至',
    'Ready to Import': '准备上传',
    'Import Successful': '导入成功',
    'We have imported all your students': '我们已成功上传您所有的学生。',
  },
}



// WEBPACK FOOTER //
// ./src/containers/pages/ImportStudent/locale.js